import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root',
})
export class MFEHelperService {
	//When we reorder the tab then we need to prevent unmount method for loading screen
	//Method is create <mfe-loader> node when it's firsttime create and update same node when go out from tab
	public createAndUpdateMFENode(
		moduleName: string,
		widgetId: string,
		enableBento = false,
		destroyNode = false
	) {
		let mfeNode;
		const widget = document.getElementById(widgetId);
		if (widget) {
			const mfe = widget.getElementsByTagName('mfe-loader');
			const widgetContent = widget.getElementsByClassName('card-body');

			Array.from(mfe).forEach((module) => {
				if (module.getAttribute('module-name') === moduleName) {
					mfeNode = module;
				}
			});

			if (!mfeNode) {
				mfeNode = document.createElement('mfe-loader');
				mfeNode.setAttribute('module-name', moduleName);

				if (enableBento) {
					mfeNode.classList.add('ng-bento');
				}
			}

			if (widgetContent !== undefined && widgetContent !== null && widgetContent.length > 0 && mfeNode) {
				(widgetContent[0] as HTMLElement).appendChild(mfeNode);

				mfeNode.preventUnmount = true;

				// It's important to destroy MFE node
				mfeNode = this.unMounting(destroyNode, mfeNode);
			}
		}
	}

	//This method is for unmounting the MFE whenever we destroy MFE life cycle
	public unMounting(destroyNode: boolean, mfeNode: any) {
		if (destroyNode) {
			mfeNode.preventUnmount = false;
			mfeNode = undefined;
		}
		return mfeNode;
	}
}
